import React from "react";

export const SrOnly: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <span className="sr-only">{children}</span>
);

export const SkipToMainLink: React.FC<{ href?: string }> = ({ href = "#main" }) => (
  <a className="skip-to-main" href={href}>
    Skip to main content
  </a>
);

export const LiveRegion: React.FC<{ role?: "status" | "alert"; children: React.ReactNode }> = ({ role = "status", children }) => (
  <div aria-live={role === "alert" ? "assertive" : "polite"} role={role}>
    {children}
  </div>
);

export const AriaAnnouncer = {
  announce(message: string, assertive = false) {
    let node = document.getElementById("aria-announcer");
    if (!node) {
      node = document.createElement("div");
      node.id = "aria-announcer";
      node.setAttribute("aria-live", assertive ? "assertive" : "polite");
      node.setAttribute("role", assertive ? "alert" : "status");
      node.style.position = "absolute";
      node.style.width = "1px";
      node.style.height = "1px";
      node.style.overflow = "hidden";
      node.style.clip = "rect(0, 0, 0, 0)" as any;
      node.style.whiteSpace = "nowrap";
      document.body.appendChild(node);
    }
    node.textContent = message;
    setTimeout(() => {
      if (node) node.textContent = "";
    }, 2000);
  },
};
